import * as React from 'react';
import { NewbuildingLayoutsContext } from '../shared/context';
import { addFavorites, removeFavorites } from '../services/favorites';
export const useFavorite = _ref => {
  let {
    setFavoriteStatus
  } = _ref;
  const {
    httpApi,
    logger
  } = React.useContext(NewbuildingLayoutsContext);
  const addOfferToFavorites = React.useCallback(offerId => {
    setFavoriteStatus(offerId, true);
    addFavorites({
      httpApi,
      logger,
      params: {
        offerId
      }
    }).then(result => {
      if (!result) {
        setFavoriteStatus(offerId, false);
      }
    });
  }, [setFavoriteStatus]);
  const removeOfferFromFavorites = React.useCallback(offerId => {
    setFavoriteStatus(offerId, false);
    removeFavorites({
      httpApi,
      logger,
      params: {
        offerId
      }
    }).then(result => {
      if (!result) {
        setFavoriteStatus(offerId, true);
      }
    });
  }, [setFavoriteStatus]);
  return {
    addOfferToFavorites,
    removeOfferFromFavorites
  };
};